<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <form @submit="submit">
              <div class="title">{{ $t('modals.automix_update.title') }}</div>
              <div>
                  <label>{{ $t('labels.blacklist') }}</label>
                  <toggles v-model='blacklist' :list='list()'/>
              </div>
              <div>
                  <label>{{ $t('labels.interval_max') }} (in seconds)</label>
                  <input v-model="intervalMax"/>
              </div>
              <div>
                  <label>{{ $t('labels.interval_min') }} (in seconds)</label>
                  <input v-model="intervalMin"/>
              </div>
              <button>{{ $t('modals.automix_update.button') }}</button>
            </form>
        </div>
    </modal>
</template>

<script>
import event from '@/services/event'

export default {
  props: {
    contributions: Array
  },
  data () {
    return {
      blacklist: [],
      intervalMax: 0,
      intervalMin: 0
    }
  },
  methods: {
    list () {
      var l = []
      this.contributions.forEach(contribution => {
        l.push({
          id: contribution.id,
          initial: this.blacklist.findIndex(id => contribution.id === id) > -1,
          name: contribution.name,
          value: contribution.id
        })
      })
      return l
    },
    show (blacklist, intervalMax, intervalMin) {
      this.blacklist = blacklist
      this.errors = {}
      this.intervalMax = intervalMax / 1e9
      this.intervalMin = intervalMin / 1e9
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    submit (e) {
      // Init
      e.preventDefault()

      // Update automix
      event.updateAutomix(this.blacklist, null, this.intervalMax * 1e9, this.intervalMin * 1e9)
        .then(() => this.hide())
        .catch(err => {
          // Process error
          var msg = this.$i18n.t('errors.default')
          if (err.isHTTP) {
            msg = err
          }

          // Toast
          this.$parent.$parent.$parent.$refs.toaster.error(msg)
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

#sub-wrapper textarea {
  height: 4.5em;
}

</style>
